import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import router from '../router'
import DomainExpired from '@/components/DomainExpired/index.js';

// 控制登出弹窗是否已显示的标识
let isShowingLogoutDialog = false

// 显示登出确认弹窗的公共函数
function showLogoutConfirm() {
  // 如果已经显示了登出弹窗，则不重复显示
  if (!isShowingLogoutDialog) {
    isShowingLogoutDialog = true
    MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      confirmButtonText: '重新登录',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      store.dispatch('LogOut').then(() => {
        // location.reload()// 为了重新实例化vue-router对象 避免bug
        router.replace({ path: '/login' });
      })
    }).finally(() => {
      // 无论用户选择什么，都重置标识
      isShowingLogoutDialog = false
    })
  }
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 20000 // 请求超时时间
})
//跨域访问带cookie 必须加这句
// axios.defaults.withCredentials = true;
// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    // 如果响应类型是blob，直接返回响应对象
    const contentType = response.headers['content-type'];
    if (contentType && (contentType.includes('application/octet-stream') || 
                        contentType.includes('application/vnd.ms-excel') || 
                        contentType.includes('application/zip') ||
                        contentType.includes('application/x-zip-compressed') ||
                        contentType.includes('application/pdf') ||
                        contentType.includes('image/') ||
                        response.config.responseType === 'blob')) {
      return response;
    }

    const res = response.data
    if (res.code !== 200) {
      // 4001:未登录;
      if (res.code === 4001) {
        showLogoutConfirm()
      }
      if (res.code === 10001) {
        // 域名失效
        DomainExpired();
        return
      }
      Message({
        message: res.message || res.msg,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject('error')
    } else {
      return response.data;
    }
  },
  error => {
    if (error.response) {
            if (error.response.status === 403) {
        showLogoutConfirm()
        return
      }
      Message({
        // message: error.message,
        message: error.response.data && error.response.data.msg || "网络连接错误",
        type: 'error',
        duration: 3 * 1000
      });
    } else {
      Message({
        // message: error.message,
        message: "网络连接错误",
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
